export default __webpack_public_path__ + "static/media/van_light.97ccd2e5.png";